var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFiletitleFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6172 6V4H7.11719V7V7.5H6.61719H3.61719V13H10.6172V12H11.6172V13V14H10.6172H3.61719H2.61719V13V6L5.61719 3H7.11719H10.6172H11.6172V4V6H10.6172ZM6.0314 4H6.11719V6.5H3.61719V6.41421L6.0314 4Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1395 7.25518L10.8414 8.55328L9.54326 7.25518L9.4372 7.14912L9.33113 7.25518L8.98009 7.60622L8.87402 7.71229L8.98009 7.81836L10.2782 9.11646L9.02808 10.3666L8.92202 10.4726L9.02808 10.5787L9.37912 10.9297L9.48519 11.0358L9.59126 10.9297L10.8414 9.67963L12.1395 10.9777L12.2455 11.0838L12.3516 10.9777L12.7026 10.6267L12.8087 10.5206L12.7026 10.4146L11.4045 9.11646L12.7026 7.81836L12.8087 7.71229L12.7026 7.60622L12.3516 7.25518L12.2455 7.14912L12.1395 7.25518Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFiletitleFalse);
export default __webpack_public_path__ + "static/media/ico-filetitle-false.fcc5c4ee67c54d32e33f1f817fffbc72.svg";
export { ForwardRef as ReactComponent };